module.exports = __webpack_public_path__ + "static/media/c3.88fb7b9e.svg";